import React from 'react'
import logo from '../../../assets/static/logo-planalto2.png'

const LogotipoPlanaltoMenorPrivate = () => (
	<img 
	className="logotipo-planalto-menor-private" 
	src={logo} 
	alt="Logotipo Planalto"
	width="150px"
	height="30px"
	 />
)

export default LogotipoPlanaltoMenorPrivate
